import { legacy_createStore as createStore, applyMiddleware, compose, } from 'redux';
import { thunk as reduxThunk } from 'redux-thunk';
import reducer from './reducers';
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var enhancer = composeEnhancers(applyMiddleware(reduxThunk));
var createApplicationStore = function () {
    return createStore(reducer, enhancer);
};
var store = createApplicationStore();
// DEBUG
window.getAppState = function () {
    return store.getState();
};
export default store;
